import { render, staticRenderFns } from "./momentList.vue?vue&type=template&id=294e3304&scoped=true"
import script from "./momentList.vue?vue&type=script&lang=js"
export * from "./momentList.vue?vue&type=script&lang=js"
import style0 from "./momentList.vue?vue&type=style&index=0&id=294e3304&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294e3304",
  null
  
)

export default component.exports